import { useContext } from "react";

import { Navigate, useRoutes } from "react-router-dom";

import DashboardContext from "../context/DashboardContext";
import Establishments from "../pages/Establishments";
import Members from "../pages/Members";
import NewEstablishment from "../pages/NewEstablishment";
import CreateOrEditMember from "../pages/CreateOrEditMember";
import Panel from "../pages/Panel";
import Settings from "../pages/Settings";
import Transactions from "../pages/Transactions";
import UserVerify from "../pages/UserVerify";
import Workers from "../pages/Workers";
import NewWorker from "../pages/NewWorker";
import EditWorker from "../pages/EditWorker";
import Categories from "../pages/Categories";
import EditCategorie from "../pages/EditCategorie";
import NewCategorie from "../pages/NewCategorie";
import SendPush from "../pages/SendPush";
import { Qrcode } from "../pages/Qrcode";
import { Movimento } from "../pages/Movimento";
import { Movimentos } from "../pages/Movimentos";
import Saude from "../pages/Saude";
import { useQuery } from "@tanstack/react-query";

export default function Router() {
  const { isLoggedIn, admin, master, clientId, fetchPermissions } = useContext(DashboardContext);
  const isLoggedInFromStorage = sessionStorage.getItem("isLoggedIn");

  const { data: permissions } = useQuery(["permissions"], fetchPermissions);

  const routes = (isLoggedIn, admin, master, clientId) => [
    {
      path: "/userVerify",
      element: isLoggedIn ? <Navigate to="/members" push /> : <UserVerify />,
    },
    {
      path: "/panel",
      element: isLoggedIn && permissions?.panel ? <Panel /> : <Navigate to="/userVerify" push />,
    },
    {
      path: "/members",
      element: isLoggedIn ? <Members /> : <Navigate to="/userVerify" push />,
    },
    {
      path: "/edit-member",
      element:
        isLoggedIn && admin === true ? (
          <CreateOrEditMember edit={true} />
        ) : (
          <Navigate to="/userVerify" push />
        ),
    },
    {
      path: "/workers",
      element:
        isLoggedIn && admin === true ? (
          <Workers />
        ) : (
          <Navigate to="/userVerify" push />
        ),
    },
    {
      path: "/new-worker",
      element:
        isLoggedIn && admin === true ? (
          <NewWorker />
        ) : (
          <Navigate to="/userVerify" push />
        ),
    },
    {
      path: "/edit-worker",
      element:
        isLoggedIn && admin === true ? (
          <EditWorker />
        ) : (
          <Navigate to="/userVerify" push />
        ),
    },
    {
      path: "/establishments",
      element: isLoggedIn ? (
        <Establishments />
      ) : (
        <Navigate to="/userVerify" push />
      ),
    },
    {
      path: "/transactions",
      element: isLoggedIn ? (
        <Transactions />
      ) : (
        <Navigate to="/userVerify" push />
      ),
    },
    {
      path: "/settings",
      element:
        (isLoggedIn && admin) || master === true ? (
          <Settings />
        ) : (
          <Navigate to="/userVerify" push />
        ),
    },
    {
      path: "/new-establishment",
      element:
        (isLoggedIn && admin) || master === true ? (
          <NewEstablishment />
        ) : (
          <Navigate to="/userVerify" push />
        ),
    },
    {
      path: "/new-member",
      element:
        (isLoggedIn && admin) || master === true ? (
          <CreateOrEditMember edit={false} />
        ) : (
          <Navigate to="/userVerify" push />
        ),
    },
    // {
    //   path: '/categories',
    //   element: isLoggedIn && admin || master === true ? <Categories/> : <Navigate to="/userVerify" push />,
    // },
    // {
    //   path: '/edit-categorie',
    //   element: isLoggedIn && admin || master === true ? <EditCategorie/> : <Navigate to="/userVerify" push />,
    // },
    // {
    //   path: '/new-categorie',
    //   element: isLoggedIn && admin || master === true ? <NewCategorie/> : <Navigate to="/userVerify" push />,
    // },
    // {
    //   path: '/send-push',
    //   element: isLoggedIn && admin || master === true ? <SendPush/> : <Navigate to="/userVerify" push />,
    // },
    {
      path: "/movimentos",
      element: isLoggedIn ? <Movimentos /> : <Navigate to="/userVerify" push />,
    },
    {
      path: "/imagem-movimento",
      element: isLoggedIn ? <Movimento /> : <Navigate to="/userVerify" push />,
    },
    {
      path: "/qrcode",
      element: isLoggedIn ? <Qrcode /> : <Navigate to="/userVerify" push />,
    },
    {
      path: "/",
      element: <Navigate to="/userVerify" push />,
    },
    {
      path: "/saude",
      element:
        clientId == 1176 ? <Saude /> : <Navigate to="/userVerify" push />,
    },
  ];

  return useRoutes(
    routes(isLoggedIn || isLoggedInFromStorage, admin, master, clientId)
  );
}
